<app-password-input
  [inputControl]="propertyForm"
  [labelTextId]="propertyType.NameId ? (propertyType.NameId | translate) : propertyType.Key"
  [propertyKey]="property.Key"
  [placeholder]="placeholder"
  [disabled]="!property.Rules.EnableIf"
  [readOnly]="property.Rules.ReadOnlyIf"
  [required]="property.Rules.RequiredIf"
  [tooltipTextId]="propertyType | tooltipTextId"
  [tooltipPosition]="'above'"
  (focusChange)="focused = $event"
></app-password-input>
